<template>
	<div id="ViewMyLqsRequest">
		<div data-html2canvas-ignore="true" class="customdim" v-show="loader">
			<!-- <div class="spinner-border" role="status">
				<span class="sr-only">Loading...</span>
			</div> -->
			<Loader />
		</div>
		<div class="container-fluid">
			<div class="">
				<div class="card d-flex justify-content-between flex-row mt-3">
					<div style="margin: 0; padding-bottom: 0 !important" class="graphHeading">
						<!-- Listing Quality Score (LQS) Analysis -->
						<!-- View LQS Request -->
						View LQS Request : {{ this.$route.params.requestName.replace(/-/g, ' ') }}
					</div>
					<!-- <router-link to="/lqs-schedule" style="text-decoration: none; float: right"> -->
					<button @click="goBack" style="width: max-content; float: right" class="btn navigationButton"
						type="button">
						<i class="fa fa-arrow-left"></i>
						<span style="font-size: 13px"> Back</span>
					</button>
					<!-- </router-link> -->
				</div>
			</div>
			<div class="row">
				<div class="col-12 mt-0">
					<div class="card">
						<div class="mt-3"
							v-show="viewMyASINsData && viewMyASINsData.data && viewMyASINsData.data.length">
							<table class="table selectable" id="MyasinTable" style="width: 100%; overflow: hidden">
								<thead class="thead-normal">
									<tr>
										<!-- <th width="1%" class="checkbox-select" v-if="viewMyASINsData.data">Select</th> -->
										<th style="padding: 10px 0 !important;" scope="col"
											v-for="th of viewMyASINsData.header" :key="th.key" class="p-2">
											{{ th.lable }}
										</th>
										<th>Actions</th>
									</tr>
								</thead>
								<tbody class="tbody-normal">
									<tr v-for="(row, i) in viewMyASINsData.data" :key="i">
										<!-- <td width="1%" class="checkbox-none checkbox-asin"><input
												@click="setIndex(row, i)" type="checkbox" name="" id=""></td> -->
										<td v-for="(d, j) in viewMyASINsData.header" :key="j" :style="[
											d.key == 'product_name' ? { width: '34%' } : { width: '10%' },
										]">
											<div style="text-transform: capitalize" v-if="d.key == 'product_asin'">
												{{ row[d.key] }}
											</div>
											<div style="text-transform: capitalize" v-else-if="d.key == 'product_fsn'">
												{{ row[d.key] }}
											</div>
											<a :href="row.product_link" target="_blanck"
												v-else-if="d.key == 'product_image'"
												style="display: flex; justify-content: center;">
												<div class="rounded"
													style="width:100px; text-transform: capitalize; background: linear-gradient(180deg, rgba(0, 0, 0, 0.05) 0%, rgba(255, 255, 255, 0) 100%); border: 1px solid #EBEBEB">
													<img :src="row[d.key]"
														style="width: 100%;mix-blend-mode: multiply; padding: 10px;" />
												</div>
											</a>
											<a :href="row.product_link" target="_blanck"
												v-else-if="d.key == 'product_name'" class="productName">
												<div style="text-transform: capitalize; color: '#000000'">
													{{ row[d.key] }}
												</div>
											</a>
											<div v-else-if="d.key == 'timestamp'">
												{{ row[d.key].split(',')[0] }}<br />{{ row[d.key].split(',')[1] }}
												<span>{{ row[d.key].split(',')[2] }}</span>
											</div>
											<div v-else>
												{{ row[d.key] }}
											</div>
										</td>
										<td style="width: 10%;">
											<div class="d-flex justify-content-center align-items-center">
												<router-link v-if="row.product_asin" :to="'/asins-detailed/' +
													row.product_asin +
													'/' +
													startDate +
													'/' +
													endDate">
													<button class="btn primarycolorShow">Show Details</button>
												</router-link>
												<router-link v-if="row.product_fsn" :to="'/fsns-detailed/' +
													row.product_fsn +
													'/' +
													startDate +
													'/' +
													endDate">
													<button class="btn primarycolorShow">Show Details</button>
												</router-link>
												<!-- <div class="deleteProductBtnContainer"
													@click="confirmDeleteProductsRow(row.product_asin ? row.product_asin : row.product_fsn ? row.product_fsn : null, row.website)">
													<b-button variant="outline-danger"><i
															class="fa fa-trash" /></b-button>
												</div> -->
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<!-- <div v-show="viewMyASINsData && !viewMyASINsData.data.length && viewMyASINsData.failed_asins && viewMyASINsData.failed_asins.length"
							class="failedAsins text-center text-danger mt-0">
							Failed ASINs
						</div>
						<div v-show="viewMyASINsData && !viewMyASINsData.data.length && viewMyASINsData.failed_fsn && viewMyASINsData.failed_fsn.length"
							class="failedAsins text-center text-danger mt-0">
							Failed FSN
						</div> -->
						<div v-if="viewMyASINsData.failed_asins && viewMyASINsData.failed_asins.length"
							class="failedAsins text-center text-danger mt-0 d-flex">
							Failed ASINs : <div class="mx-2">{{ viewMyASINsData.failed_asins.join(', ') }}
							</div>
						</div>
						<div v-if="viewMyASINsData.failed_fsn && viewMyASINsData.failed_fsn.length"
							class="failedAsins text-center text-danger mt-0 d-flex">
							Failed FSN : <div class="mx-2">{{ viewMyASINsData.failed_fsn.join(', ') }}</div>
						</div>
						<div v-show="viewMyASINsData && !viewMyASINsData.data.length && (!viewMyASINsData.failed_asins || !viewMyASINsData.failed_asins.length) && (!viewMyASINsData.failed_fsn || !viewMyASINsData.failed_fsn.length)"
							class="noData text-center text-danger mt-0">
							No Data Available.
						</div>

					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import LqsCard from "./LqsCard";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import Loader from "../Components/Loader.vue";

export default {
	name: "ViewLqsRequest",
	components: { LqsCard, Datepicker, Loader },

	data: function () {
		return {
			loader: false,
			viewMyASINsData: {
				data: [],
				failed_asins: [],
				failed_fsn: [],
				header: []
			},
			customClient: JSON.parse(localStorage.reviewUserData).data.client,
			startDate: this.$route.params.startDate,
			endDate: this.$route.params.endDate,
		};
	},

	// watch: {
	// 	deleteProductRowModal(newValue, oldValue) {
	// 		if (!newValue) {
	// 			this.storeDeleteProductId = '',
	// 				this.storeDeleteChannelName = ''
	// 		}
	// 	}
	// },

	mounted() {
		this.dataAPIs();

	},
	methods: {
		dataAPIs() {
			this.getMyASINsData();
			console.log(this.$route.params)
		},
		// dateChange() {
		// 	this.changeTableData();
		// },

		// changeTableData() {
		// 	$("#MyasinTable").DataTable().destroy();
		// 	this.getMyASINsData();
		// },

		goBack() {
			window.history.back();
		},
		getMyASINsData() {
			let self = this;
			self.loader = true;
			self.viewMyASINsData = {
				data: [],
				failed_asins: [],
				failed_fsn: [],
				header: []
			};
			let payload = {
				start: this.$route.params.startDate,
				end: this.$route.params.endDate,
				channel: this.$route.params.channelName.split('.')[0],
				request_id: this.$route.params.requestId,
				client: this.customClient
			};
			let url = '/api/v2/spider/view_lqs_request'

			self.$http.post(url, payload).then((response) => {
				// console.log(Object.keys(response.data.data).length)
				// console.log(response.data.data.data)
				if (Object.keys(response.data.data.data).length != 0) {
					self.viewMyASINsData.data = response.data.data.data.data;
					self.loader = false;
				}
				self.viewMyASINsData.failed_asins = [];
				self.viewMyASINsData.failed_fsn = [];
				if (response.data.data.data.failed_asins) {
					self.viewMyASINsData.failed_asins = response.data.data.data.failed_asins;
				}
				if (response.data.data.data.failed_fsn) {
					self.viewMyASINsData.failed_fsn = response.data.data.data.failed_fsn;
					

				}
				self.viewMyASINsData.header = response.data.data.data.header;

				self.$nextTick(() => {
					$("#MyasinTable").dataTable();
					$("#MyasinTable").DataTable().destroy();
					$("#MyasinTable").DataTable({
						autoWidth: false,
						rowReorder: true,
						sorting: true,
						columnDefs: [
							{ orderable: true, className: 'reorder', targets: 4 },
							{ orderable: false, targets: '_all' }
						],
						ordering: true,
						language: {
							search: "",
							paginate: {
								first: "",
								previous: "<",
								next: ">",
								last: "",
							},
						},
						pagingType: "full_numbers",
						order: [],
					});
					let search = require("../../../public/Icons_SVG/Search.svg");
					$("#MyasinTable_filter > label > input").attr("placeholder", "Search");
					$("#MyasinTable_filter > label").append(`<div><img src='${search}' /></div>`);
					$("#MyasinTable_length > label > select").removeClass();
				});
				self.loader = false;
			})
				.catch((err) => {
					self.loader = false;
					console.log("err");
				});
		},

	},
};
</script>

<style scoped>
.space-between {
	display: flex;
	justify-content: space-between;
}

.flex-start {
	display: flex;
	justify-content: start;
}

.mainHeading {
	color: #4e4e4e;
	margin-bottom: 0;
	font-size: 1.3125rem;
}

.secondaryHeading {
	color: #4e4e4e;
	margin-bottom: 0;
	font-size: 1rem;
	font-weight: bold;
}

.textColor {
	color: #818890 !important;
}

.flex-start {
	display: flex;
	justify-content: flex-start;
}

.inputBox input {
	border-radius: 0px;
	border: none !important;
}

.sideBorder {
	border-right: 1px solid #c1c1c1;
}

input:focus {
	outline: none !important;
	box-shadow: none !important;
}

.trueIcon {
	color: #64ac94 !important;
}

.falseIcon {
	color: #ff0000 !important;
}

.cardButton {
	margin-left: 10px;
}

.productCart {
	display: flex;
	justify-content: space-between;
	padding: 10px;
}

.productImg {
	width: 200px;
}

.product-title {
	font-size: 18px;
}

.productImg img {
	width: 100%;
}

.graphCount {
	font-size: 24px;
	color: "#533a79";
	font-weight: 700;
}

.asinBadge {
	/* background: '#9683b3'; */
	background: "#9683b3";
}

.cross-icon {
	color: black;
	background: white;
}

.crossIcon {
	cursor: pointer;
	font-size: 8px;
}

.space-between {
	display: flex;
	justify-content: space-between;
}

.pinkColor {
	background: rgb(255 185 185);
	font-weight: bold;
}

.skyColor {
	background: rgb(199 224 255);
	font-weight: bold;
}

.no-data {
	font-size: 16px;
	text-align: center;
	padding: 10px;
	color: red;
}

.details-btn {
	background: #533a79;
	color: white;
	border-radius: 0;
	padding: 3px 22px;
	border: 1.6px solid #533a79;
}

.productName {
	color: #5a5a5a;
	text-align: center;
}

.navigationButton {
	height: 35px;
	border: none;
	margin: 0;
	background: var(--accent_color);
	color: white;
	border-radius: 5px;
	font-size: 14px;
	font-weight: bold;
	padding: 0px 20px;
	letter-spacing: 0.2px;
	font-family: "poppins";
}

.navigationButton:hover {
	background: var(--accent_color-80);
}

.card {
	border-radius: 0.7rem !important;
	border: none !important;
	margin-bottom: 1rem;
}

select option {
	text-transform: capitalize;
	padding: 10px 0px;
}

select {
	font-family: "Poppins", sans-serif;
}

.customSelect select {
	/* border: 1px solid rgb(228, 231, 234) !important; */
	border: 1px solid var(--base_color-40) !important;
	height: 35px;
	border-radius: 5px !important;

}

.customSelect :focus {
	background: var(--base_color-5);
	color: var(--primary_brand-60);
	border: 1px solid var(--primary_brand-60) !important;
	outline: none;
	box-shadow: none;
	font-weight: 600;
}

.productNameHeading {
	border-bottom: 1px solid #D5D5D5;
	font-size: 16px;
	color: #065559;
}

/* .productBorder {
	border: 1px solid #D5D5D5 !important;
} */

.deleteProductBtnContainer {
	/* width: 20px;
  height: 20px; */
	cursor: pointer !important;
	/* transform: scale(1); */
	transition: .2s all linear;
}

/* .deleteProductBtnContainer:hover {
	transform: scale(1.2);
} */

button.primarycolorShow {
	background: var(--primary_brand);
	font-family: "Poppins", sans-serif;
	color: white;
	padding: 6px;
	border-radius: 6px;
	letter-spacing: 0.2px;
	font-weight: 100;
	font-size: 14px;
}

button.primarycolorShow:hover {
	color: white;
	background: var(--primary_brand-80);
	/* border: 1.6px solid var(--base_color); */
}

.delete-alert {
	background-color: #ffecec !important;
	color: var(--red);
	font-size: 30px;
	width: 45px;
	height: 45px;
}


@media screen and (max-width:1600px) {
	button.primarycolorShow {
		font-size: 10px !important;
	}
}
</style>
<style>
#MyasinTable_filter>label {
	display: flex;
	flex-direction: row;
	justify-content: end;
}

#MyasinTable_filter input {
	border-radius: 5px 0 0 5px !important;
	height: 35px;
	width: 220px;
	margin-bottom: 8px;
	outline: none;
	border-color: var(--primary_brand-60);
	border-right: none;
	padding: 10px 15px !important;
}

#MyasinTable_filter input:focus {
	border-color: var(--primary_brand) !important;
	outline: none !important;
	box-shadow: none !important;
}

#MyasinTable_filter input::placeholder {
	color: var(--primary_brand-40) !important;
}

#MyasinTable_filter input:-ms-input-placeholder {
	color: var(--primary_brand-40) !important;
}

#MyasinTable_filter input::-ms-input-placeholder {
	color: var(--primary_brand-40) !important;
}

#MyasinTable .page-item:focus {
	border: none !important;
	outline: none !important;
	box-shadow: none !important;
	box-shadow: none;
}

#MyasinTable_filter div {
	height: 35px;
	width: 35px;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 5px;
	margin-left: -3px;
	background-color: var(--primary_brand);
}

#MyasinTable_filter img {
	height: 17px;
	filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg) brightness(103%) contrast(104%);
}

#MyasinTable_paginate {
	position: relative;
	top: 12px;
	z-index: 100;
	float: right;
	width: 50vw;
}

#MyasinTable_info {
	position: relative;
	top: 9px;
	left: 324px;
	z-index: 100;
	float: right;
	width: 50vw;
	font-size: 15px;
	/* font-weight: 600; */
	color: var(--primary_brand-80);
}

#MyasinTable_length label {
	border-style: solid;
	border-width: thin;
	padding: 0 5px;
	height: 35px;
	border-radius: 5px;
	width: 170px;
	border-color: var(--primary_brand-40);
	display: flex;
	justify-content: space-between;
	align-items: center;
}

#MyasinTable_length h5 {
	width: fit-content;
	text-align: center;
	display: flex;
	flex-direction: column;
	justify-content: center;
	text-transform: none;
	padding: 10px 0 10px 10px;
	font-size: 15px;
	color: var(--primary_brand-80);
	margin: 0;
}

#MyasinTable_length select {
	width: 30px;
	height: 100%;
	text-align-last: center;
	border-radius: 5px;
	margin-right: 0px !important;
	-webkit-appearance: none !important;
	-moz-appearance: none !important;
	appearance: none !important;
	border-color: var(--primary_brand-40) !important;
	background-color: #fff !important;
	color: var(--primary_brand-80);
	/* cursor: pointer !important; */
}

#MyasinTable_length select:focus-visible {
	box-shadow: none !important;
	outline: none !important;
}

#MyasinTable_paginate .page-link {
	border: none !important;
	background: none !important;
	color: var(--primary_brand-80) !important;
}

#MyasinTable_paginate ul.pagination li.active {
	border: 1px solid var(--primary_brand-40) !important;
	border-radius: 7px;
	box-shadow: none !important;
}

#MyasinTable {
	border-radius: 0 0 0 0 !important;
}

#MyasinTable .thead-normal,
#MyasinTable .thead-normal tr:first-child,
#MyasinTable .thead-normal>tr:first-child>th:first-child {
	/* background-color: var(--background) !important; */
	background-color: none !important;
	background: #0655590a !important;
	border-radius: 0 !important;
	border-left: 1px solid var(--base_color-20) !important;
}

#MyasinTable .thead-normal>tr:last-child>th:first-child {
	/* border-left: 1px solid var(--base_color-20) !important; */
	border-left: none !important;
}

#MyasinTable .thead-normal>tr:first-child>th:last-child {
	border-radius: 0 0 0 0 !important;
}

#MyasinTable .thead-normal>tr:first-child>th {
	font-size: 14px;
	letter-spacing: 0.1px;
	font-weight: 300 !important;
	text-align: center !important;
	padding: 5px 25px 0px 25px !important;
	color: rgb(78 78 78) !important;
	/* border-top: 1px solid var(--base_color-20) !important; */
	/* border-right: 1px solid var(--base_color-20) !important; */
	border-top: none !important;
	border-right: none !important;

}

#MyasinTable .thead-normal>tr:last-child>th {
	font-size: 14px;
	letter-spacing: 0.1px;
	font-weight: 300 !important;
	text-align: center !important;
	padding: 0px 25px 5px 25px !important;
	color: rgb(78 78 78) !important;
	/* border-right: 1px solid var(--base_color-20) !important; */
	border-right: none !important;
}

#MyasinTable .thead-normal>tr>th.sorting:before {
	font-size: 12px !important;
	bottom: 60% !important;
	color: var(--base_color-80);
}

#MyasinTable .thead-normal>tr>th.sorting:after {
	font-size: 12px;
	top: 50%;
	color: var(--base_color-80);
}

#MyasinTable th select {
	background-color: #fff !important;
	filter: brightness(99%);
	border: 1px solid #b1b1b1 !important;
	width: 100%;
	color: var(--primary_brand-60);
	font-size: 10px;
	border-radius: 7px;
	height: 33px;
}

#MyasinTable tfoot th {
	/* background-color: var(--background) !important; */
	background-color: #0655590a !important;
	/* border-right: 1px solid var(--base_color-20) !important; */
	border-bottom: 1px solid var(--base_color-20) !important;
	padding: 5px !important;
}

#MyasinTable tfoot th:first-child {
	/* background-color: var(--background) !important; */
	background-color: #fff !important;
	border-left: 1px solid var(--base_color-20) !important;
	padding: 5px !important;
}

#MyasinTable tbody td {
	border-bottom: 1px solid var(--base_color-20) !important;
	/* border-right: 1px solid var(--base_color-20) !important; */
	font-size: 13px !important;
	font-family: "Heebo", sans-serif !important;
}

#MyasinTable tbody td:first-child {
	/* border-left: 1px solid var(--base_color-20) !important; */
	border-left: none !important;
}

#MyasinTable .even td {
	background: #fff !important;
}

#MyasinTable .odd td {
	background: #fff !important;
	/* filter: brightness(110%); */
}

#MyasinTable_wrapper>.row:last-child {
	margin-bottom: 15px;
}

#MyasinTable_wrapper .scrolledDataTable {
	border-left: none;
	border-right: none;
}

#MyasinTable_wrapper .scrolledDataTable::-webkit-scrollbar-track {
	-webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
	border-radius: 10px;
	background: var(--base_color-10);
}

#MyasinTable_wrapper .scrolledDataTable::-webkit-scrollbar {
	height: 10px;
}

#MyasinTable_wrapper .scrolledDataTable::-webkit-scrollbar-thumb {
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
	background: var(--base_color-40);
}

#MyasinTable_wrapper .scrolledDataTable::-webkit-scrollbar-thumb:hover {
	background: var(--base_color-60);
}

button.primarycolor {
	background: var(--primary_brand);
	font-family: "Poppins", sans-serif;
	color: white;
	padding: 4px 25px;
	border-radius: 6px;
	letter-spacing: 0.2px;
	font-weight: bold;
	font-size: 16px;
}

button.primarycolor:hover {
	color: white;
	background: var(--primary_brand-80);
	/* border: 1.6px solid var(--base_color); */
}

#MyasinTable input[type="checkbox"]:checked {
	background-color: var(--primary_brand) !important;
	accent-color: var(--primary_brand) !important;
}

#MyasinTable input[type="checkbox"]:hover {
	cursor: pointer;
}

table.dataTable#MyasinTable td,
table.dataTable#MyasinTable th {
	border-right: none !important;
}

table.dataTable#MyasinTable th {
	background-color: #0655590a !important;
}

/* table.dataTable#MyasinTable td:last-child, table.dataTable#MyasinTable th:last-child {
    border-right: 1px solid #D5D5D5 !important;
} */

table.dataTable#MyasinTable th:first-child {
	border-left: none !important;
}

#MyasinTable_wrapper .row:nth-child(2) {
	border: 1px solid #D5D5D5 !important;
	margin: 10px 0 0 0 !important;
	padding-bottom: 14px !important;
	border-radius: 7px;
}

#MyasinTable .dataTables_empty {
	color: var(--red);
}

.bgInfoColor {
	color: #818181;
}

.noData,
.failedAsins {
	border: 1px solid #fbb1b1;
	border-radius: 5px;
	padding: 10px;
	background: #fff7f7;
}

.graphHeading {
	font-weight: 600 !important;
	font-size: 18px !important;
	color: var(--primary_brand) !important;
	letter-spacing: 0.6px !important;
	font-family: "poppins";
}

/* #MyasinTable thead>tr>th.sorting_asc:before, #MyasinTable thead>tr>th.sorting_asc::after{
	display: none !important;
} */
</style>
